<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import ImagePreview from "../ImagePreview.svelte"

    export let imageData: Media[] = []

    const dispatch = createEventDispatcher()

    const handleClick = (e: Event) => {
        e.stopPropagation()
        e.preventDefault()
        dispatch("openImageModal")
    }
    let innerWidth = 0
    $: isMobile = innerWidth < 1700
    $: amountOfVisibleImages = isMobile ? 2 : 12
</script>

<svelte:window bind:innerWidth="{innerWidth}" />
<div class="image-preview-row">
    {#each imageData.slice(0, amountOfVisibleImages) as image}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            on:click="{handleClick}"
            class="image-wrapper"
        >
            <ImagePreview image="{image}" />
        </div>
    {/each}

    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    {#if imageData.length > amountOfVisibleImages}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="image-wrapper"
            on:click="{handleClick}"
        >
            <ImagePreview image="{imageData[amountOfVisibleImages]}" />
            {#if imageData.length > amountOfVisibleImages + 1}
                <div class="overlay">+{imageData.length - amountOfVisibleImages}</div>
            {/if}
        </div>
    {/if}

    <button
        class="editImages"
        on:click|stopPropagation|preventDefault="{() => dispatch('uploadImage')}"
    >
        <img
            src="../../../assets/icons/solar_pen-outline.svg"
            alt="icon"
        />
    </button>
    <button
        class="editImages"
        on:click="{handleClick}"
    >
        <img
            src="../../../assets/icons/solar_album-outline.svg"
            alt="icon"
        />
    </button>
</div>

<style lang="less">
    .image-preview-row {
        display: flex;
        gap: 6px;
    }

    .image-wrapper,
    .editImages {
        height: 2.7rem;
        width: 2.7rem;
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            font-family: Inter;
            font-size: 0.5rem;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: uppercase;
        }
    }

    .editImages {
        border-radius: 6px;
        border: 1px solid var(--text-200);
        img {
            height: 1.2rem;
            width: 1.2rem;
        }
    }
</style>
